import { TriggerPayloadConfiguration } from './trigger-payload-configuration';
import { EnrolmentNotRecognizedPayloadValidation } from './validation/enrolment-not-recognized-trigger-payload-validation';
import { TriggerPayloadValidation } from './validation/trigger-payload-validation';

export class EnrolmentNotRecognizedTriggerPayloadConfiguration extends TriggerPayloadConfiguration {
	public constructor() {
		// No note: the reason is now captured by the structured review-reason step, one screen earlier.
		super(false, false, false, false);
	}

	public createValidation(): TriggerPayloadValidation {
		return new EnrolmentNotRecognizedPayloadValidation();
	}
}
